import Modal from 'bootstrap/js/src/modal';

window.chooseDates = (target) => {
    document.querySelectorAll('[data-component=modal-choose-dates]').forEach((modal) => {
        modal.querySelectorAll('form').forEach((form) => form.setAttribute('action', target));
        Modal.getOrCreateInstance(modal).show();
    });
};
